import { api } from "@/shared/lib/axios/axios.api"
import { NOTIFICATION_API_PREFIX } from "@/shared/lib/axios/axios.constants"
import { handleAxiosError } from "@/shared/lib/axios/axios.lib"

export const pushAlarm = async () => {
  try {
    const response = await api.patch(`${NOTIFICATION_API_PREFIX}/push_alarm`)

    return response.data
  } catch (error) {
    return handleAxiosError(error)
  }
}

export const clickAlarm = async ({ pushMsgId }: { pushMsgId: string }) => {
  try {
    const response = await api.patch(`${NOTIFICATION_API_PREFIX}/push_msg`, {
      pushMsgId,
    })

    return response.data
  } catch (error) {
    return handleAxiosError(error)
  }
}
